<script :route="{path: '/fin/components/payee_company_detail',noChkout: true,}">
  import PCUtil from "../../payee_company/libs/util";
  import OnlineStockSelector from "../../stock/components/online_payee_company_stock_selector";
  import { telephoneReg, mobileReg } from '../../../libs/common_regular.js';


  export default {
    /* router_info_start */
    router_info: {
      path: "/fin/components/payee_company_detail",
      noChkout: true,
    },
    /* router_info_end */

    components: { OnlineStockSelector },
    data() {
      return {
        company_details: "",
        payee_company_account_columns: [
          {
            title: "账户名",
            align: "left",
            key: "account",
            render: (h, params) => {
              const account = params.row.account;
              if (account == null || account.length === 0) {
                return h("span", "-");
              } else {
                return h("span", account);
              }
            },
          },
          {
            title: "银行开户行",
            align: "left",
            key: "bank",
            render: (h, params) => {
              const bank = params.row.bank;
              if (bank == null || bank.length === 0) {
                return h("span", "-");
              } else {
                return h("span", bank);
              }
            },
          },
          {
            title: "卡号 / 账号",
            align: "left",
            key: "bank_number",
            render: (h, params) => {
              const count = params.row.bank_number;
              if (count == null || count.length === 0) {
                return h("span", "-");
              } else {
                return h("span", count);
              }
            },
          },
          {
            title: "账户类型",
            align: "left",
            key: "bank_type",
            render: (h, params) => {
              const type = params.row.bank_type;
              if (type === 0) {
                return h("span", "银行卡");
              } else if (type === 10) {
                return h("span", "PayPal");
              } else if (type === 20) {
                return h("span", "支付宝");
              }
              return h(
                "span",
                {
                  class: {
                    "color-error": true,
                  },
                },
                "未定义账号类型"
              );
            },
          },
          {
            title: "开户省",
            align: "left",
            key: "province",
            width: 80,
            render: (h, params) => {
              const province = params.row.province;
              if (province == null || province.length === 0) {
                return h("span", "-");
              } else {
                return h("span", province);
              }
            },
          },
          {
            title: "开户市",
            align: "left",
            key: "city",
            width: 80,
            render: (h, params) => {
              const city = params.row.city;
              if (city == null || city.length === 0) {
                return h("span", "-");
              } else {
                return h("span", city);
              }
            },
          },
          {
            title: "账户备注",
            align: "left",
            key: "remark",
            render: (h, params) => {
              const remark = params.row.remark;
              if (remark == null || remark.length === 0) {
                return h("span", "-");
              } else {
                return h("span", remark);
              }
            },
          },
        ],
        edit_config: {
          modal: false,
          loading: true,
        },
        edit_payee_company: {},
        edit_payee_company_contact_rules: {
          address: {
            required: true, 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if(!value) {
                callback(new Error('收货地址不能为空'))
              }
              if(value.getByteSize() > 255){
                callback(new Error('收货地址不能超过255个字节'))
              }
              callback()
            }
          },
          contact_person: {
            required: true, 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if(!value) {
                callback(new Error('收件人名称不能为空'))
              }
              if(value.getByteSize() > 64){
                callback(new Error('收件人名称不能超过64个字节'))
              }
              callback()
            }
          },
          phone: {
            required: true, 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if(!value) {
                callback(new Error('收件人电话不能为空'))
              }
              if (!(telephoneReg.test(value) || mobileReg.test(value))) {
                callback(new Error('收件人电话号码错误'))
              }
              callback()
            }
          },
        },
        edit_payee_company_rules: {
          name: [{ required: true, message: "供应商名称不能为空" }],
          main_products: [{ required: false, message: "主营产品不能为空" }],
          process_mode: [{ required: false, message: "请输入供应商加工方式" }],
          group: [{ required: true, message: "分组不能为空" }],
          id_number: [
            {
              validator: (rule, value, callback, source, options) => {
                const errors = [];
                if (this.edit_payee_company.company_type === 0 && !value) {
                  errors.push("个人证件号码不能为空");
                }
                if (value && value.length >= 15 && !Util.IDCheck(value)) {
                  errors.push("请填写正确的证件号码");
                }
                callback(errors);
              },
            },
          ],
          contacts: [{ required: false, message: "联系人不能为空" }],
        //tel_no: [
        //    {required: false, message: ''},
        //    {validator: (rule, value, callback, source, options)=>{
        //        let errors = [];
        //        //if(this.edit_payee_company.tel_no === 0 && !value){
        //        //    errors.push('电话号码不能为空');
        //        //}
        //        if(value && !Util.mobileCheck(value)){
        //            errors.push('请填写正确的电话号码');
        //        }
        //        callback(errors);
        //    }}
        //]
        },
        bank_type_rules: {
          required: true,
          validator: (rule, value, callback, source, options) => {
            const errors = [];
            if (value === -1) {
              errors.push("请选择账户类型");
            }
            callback(errors);
          },
        },
        edit_payee_company_account_rules: {
          account: [{ required: true, message: "账户名不能为空" }],
          bank: [{ required: true, message: "银行不能为空" }],
          bank_number: [{ required: true, message: "银行卡号不能为空" }],
        },
        new_payee_company_cooperation_info: {
          inner_name: "",
          short_name: "",
          product_type_id: -1,
          create_user: "",
        },
        new_payee_company_contact: {
          address: '',
          contact_person: '',
          phone: '',
        },
        new_payee_company_account: {
          account: "",
          bank_type: -1,
          bank: "",
          bank_number: "",
          province: "",
          city: "",
          remark: "",
        },
        groups: PCUtil.groups,
      };
    },
    computed: {},
    computed: {
      customer() {
        const base = {
          id: "",
          groups: [],
          is_director: false,
          is_outsource_director: false,
          is_team_leader: false,
          is_formal: false,
        };
        return Object.assign(base, this.$store.state.cur_customer);
      },
    },
    created() {
      this.getCompanyDetails();
    },
    methods: {
      setInnerName(item, inner_name, stock_name, product_type_id) {
        item.inner_name = inner_name;
        item.short_name = stock_name;
        item.product_type_id = product_type_id;
      },
      /**getMoreItemInfo(){
            let payee_company = this.company_details;
            let cur_id = payee_company.id;
            let cur_company_name = payee_company.name;
            let routeData = this.$router.resolve({
                path: '/fin/components/payee_company_cooperation_item_info',
                query: {
                    company_id: cur_id,
                    cur_search: 1,
                    cur_company_name: cur_company_name
                }
            });
			window.open(routeData.href, '_blank');
        },
        getMoreItemInfo(){
            let payee_company = this.company_details;
            let cur_id = payee_company.id;
            let cur_company_name = payee_company.name;
                this.$router.push({
                    path: '/fin/components/payee_company_cooperation_item_info',
                    query: {
                        company_id: cur_id,
                        cur_search: 1,
                        cur_company_name: cur_company_name
                    }
                });
            },**/
      getMoreItemInfo() {
        const payee_company = this.company_details;
        const cur_id = payee_company.id;
        const cur_company_name = payee_company.name;

        this.$router.push({
          path: "/fin/components/payee_company_cooperation_item_info",
          query: {
            company_id: cur_id,
            cur_search: 1,
            cur_company_name: cur_company_name,
          },
        });
      },
      inGroup(group) {
        const len = arguments.length;
        for (let i = 0; i < len; i++) {
          if (this.customer.groups.indexOf(arguments[i]) > -1) {
            return true;
          }
        }
        return false;
      },
      fileUrl(filepath) {
        if (
          filepath.indexOf("http://cdn1.mall.baicizhan.com/rc201603281546") > -1
        ) {
          filepath = filepath.replace(
            "http://cdn1.mall.baicizhan.com/rc201603281546",
            ""
          );
          return Util.mallFileUrl(filepath);
        } else {
          return filepath;
        }
      },
      getCompanyDetails() {
        const cur_id = this.$route.query.company_details_id;
        Util.ajax
          .get(Util.api.query_payee_company_withid, { params: { id: cur_id } })
          .then((response) => {
            return response.data;
          })
          .then((res) => {
            if (res.code === 1) {
              if (res.data.length == 1) {
                this.company_details = res.data[0];
              } else {
                this.$Modal.error({
                  title: "提示",
                  content: "获取更多供应商信息失败！",
                });
              }
            } else {
              this.$Modal.error({ title: "提示", content: res.msg });
            }
          })
          .catch((e) => {
            this.$Modal.error({ title: "提示", content: e.message });
          })
          .finally();
      },
      getCompanyGroupName(company_details) {
        return PCUtil.getCompanyGroupName(company_details.group);
      },
      payeeCompanyType(company_details) {
        if (company_details.company_type === 0) {
          return "个人";
        } else if (company_details.company_type === 1) {
          return "公司";
        } else {
          return "未设置";
        }
      },
      deletePayeeCompanyCooperationInfo(
        payee_company,
        payee_company_cooperation_info,
        index
      ) {
        if (payee_company_cooperation_info.id) {
          Util.ajax
            .post(Util.api.delete_payee_company_cooperation_info, {
              id: payee_company.id,
              payee_company_cooperation_info_id:
                payee_company_cooperation_info.id,
            })
            .then((response) => {
              return response.data;
            })
            .then((data) => {
              if (data.code === 1) {
                this.edit_payee_company.payee_company_cooperation_infos.splice(
                  index,
                  1
                );
                this.$Message.success("删除成功!");
              } else {
                this.$Modal.error({
                  title: "提示",
                  content: data.msg,
                });
              }
            })
            .catch((e) => {
              console.log(e);
              this.$Modal.error({
                title: "提示",
                content: "删除失败",
              });
            });
        } else {
          this.edit_payee_company.payee_company_cooperation_infos.splice(
            index,
            1
          );
          this.$Message.success("删除成功!");
        }
      },
      addPayeeCompanyCooperationInfo() {
        const new_payee_company_cooperation_info = Util.clone(
          this.new_payee_company_cooperation_info
        );
        new_payee_company_cooperation_info.create_user = this.customer.id;
        const obj = new_payee_company_cooperation_info;
        Object.keys(obj).forEach((item) => {
          this.$set(obj, item, obj[item]);
        });
        this.edit_payee_company.payee_company_cooperation_infos.push(obj);
      },
      editPayeeCompany(company_details) {
        this.edit_payee_company = Util.clone(company_details);
        this.edit_config.modal = true;
      },
      addPayeeCompanyAccount() {
        this.edit_payee_company.payee_company_accounts.push(
          Util.clone(this.new_payee_company_account)
        );
      },
      addPayeeCompanyContact() {
        this.edit_payee_company.payee_company_contacts.push(
          Util.clone(this.new_payee_company_contact)
        );
      },
      deletePayeeCompanyAccount(payee_company, payee_company_account, index) {
        if (payee_company.payee_company_accounts.length <= 1) {
          this.$Message.error("不能删除, 至少保留一个付款账号");
          return;
        }
        if (payee_company_account.id) {
          Util.ajax
            .post(Util.api.delete_payee_company_account, {
              id: payee_company.id,
              payee_company_account_id: payee_company_account.id,
            })
            .then((response) => {
              return response.data;
            })
            .then((data) => {
              if (data.code === 1) {
                this.edit_payee_company.payee_company_accounts.splice(index, 1);
                this.$Message.success("删除成功!");
              } else {
                this.$Modal.error({
                  title: "提示",
                  content: data.msg,
                });
              }
            })
            .catch((e) => {
              console.log(e);
              this.$Modal.error({
                title: "提示",
                content: "删除失败",
              });
            });
        } else {
          this.edit_payee_company.payee_company_accounts.splice(index, 1);
          this.$Message.success("删除成功!");
        }
      },
      deletePayeeCompanyContact(id, index, companyId) {
        if(id){
          Util.ajax
            .post(Util.api.delete_payee_company_contact, { id })
            .then((response) => {
              return response.data;
            })
            .then((data) => {
              if (data.code === 1) {
                this.edit_payee_company.payee_company_contacts.splice(index, 1);
                this.company_details.payee_company_contacts.splice(index, 1);
                this.$Message.success("删除成功!");
              } else {
                this.$Message.error('不能删除，已与存货编码进行了关联');
              }
          })
            .catch((e) => {
              console.log(e);
              this.$Message.error('删除失败');
          });
        } else {
          this.edit_payee_company.payee_company_contacts.splice(index, 1);
          this.company_details.payee_company_contacts.splice(index, 1);
          this.$Message.success("删除成功!");
        }
      },
      editOK() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const { payee_company_contacts, ...restParams } = this.edit_payee_company;
            const params = {
              ...restParams,
              payee_company_contacts: payee_company_contacts.map(item => {
                const { id, contact_person, phone, address } = item;
                return id ? { id, contact_person, phone, address } : { contact_person, phone, address };
              })
            };
            Util.ajax
              .post(Util.api.update_payee_company, params)
              .then((response) => {
                return response.data;
              })
              .then((data) => {
                if (data.code === 1) {
                  this.edit_config.modal = false;
                  //编辑成功后，刷新当前信息为编辑信息数据
                  this.getCompanyDetails();
                  this.$Message.success({
                    content: "操作成功!",
                  });
                } else {
                  this.$Modal.error({ title: "提示", content: data.msg });
                }
              })
              .catch((e) => {
                this.$Modal.error({ title: "提示", content: e.message });
              })
              .finally(() => {
                this.edit_config.loading = false;
                setTimeout(() => {
                  this.edit_config.loading = true;
                }, 500);
              });
          } else {
            this.$Message.error("表单验证失败!请检查必输项是否设置完成。");
            this.edit_config.loading = false;
            setTimeout(() => {
              this.edit_config.loading = true;
            }, 100);
          }
        });
      },
      open_mall_backend(item_id) {
        const baseUrl =
          process.env.NODE_ENV == "production"
            ? "https://mallbackend.baicizhan.com/stocks/item_sold_stat?id="
            : "http://test.mallbackend.baicizhan.com/stocks/item_sold_stat?id=";
        const url = baseUrl + item_id;
        window.open(url);
      },
    },
  /**  beforeRouteLeave (to, from, next) {
            let toDepth = to.path.split('/').length;
            let fromDepth = from.path.split('/').length;
            if (toDepth < fromDepth) {
                to.meta.keepAlive = true;
                next();
            }
        },*/
  };
</script>>


<template>
  <div class="payee-company-container">
    <div class="line">
      <span
        class="card-title"
        :class="{'color-error': company_details.is_abnormal}"
      >{{ company_details.name }}</span>
      <span
        v-if="company_details.del"
        class="color-error"
      >(已废弃)</span>

      <span
        class="card-btn color-info"
        @click.prevent="editPayeeCompany(company_details)"
      >
        <Icon type="md-create" />编辑
      </span>
      <div
        v-if="company_details.is_abnormal"
        class="line color-error"
      >
        <span>已列入黑名单:</span>
        <span v-html="company_details.abnormal_reason" />
      </div>
    </div>

    <div class="list-container">
      <div
        class="card"
        style="margin-bottom:0;border-bottom:0px"
      >
        <div>
          <span class="card-title1">基本信息</span>
        </div>
      </div>

      <div class="card">
        <Row class="line linestyle-show">
          <i-col>
            <span class="linestyle">主营产品:</span>
            <span>{{ company_details.main_products || '无' }}</span>
          </i-col>
        </Row>
        <Row class="line linestyle-show">
          <i-col>
            <span class="linestyle">加工方式:</span>
            <span>{{ company_details.process_mode || '无' }}</span>
          </i-col>
        </Row>

        <Row class="line linestyle-show">
          <i-col>
            <span class="linestyle">财务供应商分组:</span>
            <span>{{ getCompanyGroupName(company_details) || '未设置' }}</span>
          </i-col>
        </Row>

        <Row class="line linestyle-show">
          <i-col>
            <span class="linestyle">供应商类型:</span>
            <span>{{ payeeCompanyType(company_details) }}</span>
            <span
              v-if="company_details.company_type === 0"
            >&nbsp;&nbsp;&nbsp;证件号: {{ company_details.id_number || '-' }}</span>
          </i-col>
        </Row>
        <Row class="line linestyle-show">
          <i-col>
            <span class="linestyle">供应商备注:</span>
            <span>{{ company_details.desc || '无' }}</span>
          </i-col>
        </Row>
      </div>
      <div
        class="card"
        style="margin-bottom:0;border-bottom:0px"
      >
        <div>
          <span class="card-title1">合作商品信息</span>
          <a
            style="float:right;margin-top:5px"
            @click.prevent="getMoreItemInfo()"
          >更多合作商品信息</a>
        </div>
      </div>

      <div class="card">
        <Row>
          <i-col span="24">
            <span class="cs_item">合作商品信息展示</span>

            <div
              v-if="company_details.payee_company_cooperation_infos.length > 0"
              style="overflow-x: hidden; width:100%;"
            >
              <i-col
                v-for="(info,index) in company_details.payee_company_cooperation_infos"
                :key="index"
                class="cs_item_view"
              >
                <div v-if="info.stock_img">
                  <a>
                    <img
                      width="140px"
                      height="140px"
                      :src="fileUrl(info.stock_img)"
                      @click="open_mall_backend(info.item_id)"
                    >
                  </a>
                  <a
                    style="width:140px; line-height:30px; text-align:left;text-overflow:ellipsis; white-space:nowrap; overflow:hidden; display:block;"
                    @click="open_mall_backend(info.item_id)"
                  >{{ info['short_name'] }}</a>
                </div>
                <div v-else>
                  <a>
                    <img
                      width="140px"
                      height="140px"
                      src="../../../image/without_image.jpeg"
                      @click="open_mall_backend(info.item_id)"
                    >
                  </a>
                  <a
                    style="width:140px; line-height:30px; text-align:left;text-overflow:ellipsis; white-space:nowrap; overflow:hidden; display:block;"
                    @click="open_mall_backend(info.item_id)"
                  >{{ info['short_name'] }}</a>
                </div>
              </i-col>
            </div>
            <span v-else>
              <img
                width="100px"
                height="100px"
                src="../../../image/without_img.png"
              >
            </span>
          </i-col>
        </Row>
      </div>
      <div class="card" style="margin-bottom:0;border-bottom:0px">
        <div>
          <span class="card-title1">收货信息</span>
        </div>
      </div>

      <div class="card">
        <template v-if="company_details.payee_company_contacts.length">
          <div
            v-for="(detail, index) in company_details.payee_company_contacts"
            :key="index + 1"
          >
            <div class="contact-title">收货信息-{{ index + 1 }}</div>
            <Row class="line linestyle-show">
              <i-col span="8">
                <span class="linestyle">收货地址:</span>
                <span>{{ detail.address || '无' }}</span>
              </i-col>
              <i-col span="8">
                <span class="linestyle">收货人:</span>
                <span>{{ detail.contact_person || '无' }}</span>
              </i-col>
              <i-col span="8">
                <span class="linestyle">收货电话:</span>
                <span>{{ detail.phone || '无' }}</span>
              </i-col>
            </Row>
          </div>
        </template>
        <template v-else>
          <div>暂无数据</div>
        </template>
      </div>
      <div
        class="card"
        style="margin-bottom:0;border-bottom:0px"
      >
        <div>
          <span class="card-title1">联系方式</span>
        </div>
      </div>

      <div class="card">
        <Row class="line linestyle-show">
          <i-col span="6">
            <span class="linestyle">联系人:</span>
            <span>{{ company_details.contacts || '无' }}</span>
          </i-col>
          <i-col span="6">
            <span class="linestyle">联系电话:</span>
            <span>{{ company_details.tel_no || '无' }}</span>
          </i-col>
          <i-col span="6">
            <span class="linestyle">微信:</span>
            <span>{{ company_details.wechat_no || '无' }}</span>
          </i-col>
          <i-col span="6">
            <span class="linestyle">QQ:</span>
            <span>{{ company_details.qq_no || '无' }}</span>
          </i-col>
        </Row>
      </div>

      <div
        class="card"
        style="margin-bottom:0;border-bottom:0px"
      >
        <div>
          <span class="card-title1">账户信息</span>
        </div>
      </div>

      <div class="card">
        <div class="card-item">
          <Table
            :columns="payee_company_account_columns"
            :data="company_details.payee_company_accounts"
            size="small"
          />
        </div>
      </div>
    </div>

    <Modal
      v-model="edit_config.modal"
      width="750"
      title="编辑"
      ok-text="保存"
      :loading="edit_config.loading"
      :mask-closable="false"
      @on-ok="editOK"
    >
      <Form
        ref="form"
        :model="edit_payee_company"
        :rules="edit_payee_company_rules"
        label-position="top"
      >
        <Row :gutter="4">
          <i-col span="12">
            <Form-item
              label="供应商名称"
              prop="name"
            >
              <i-input
                v-model.trim="edit_payee_company.name"
                placeholder="请输入供应商名称..."
              />
            </Form-item>
          </i-col>
        </Row>

        <Form-item
          label="主营产品"
          prop="main_products"
        >
          <i-input
            v-model.trim="edit_payee_company.main_products"
            type="textarea"
            :rows="2"
            placeholder="请输入供应商主营产品..."
          />
        </Form-item>

        <Form-item
          label="加工方式"
          prop="process_mode"
        >
          <i-input
            v-model.trim="edit_payee_company.process_mode"
            type="textarea"
            :rows="2"
            placeholder="请输入供应商加工方式..."
          />
        </Form-item>

        <Row :gutter="4">
          <i-col span="8">
            <Form-item
              label="分组设置"
              prop="group"
            >
              <Select v-model="edit_payee_company.group">
                <Option
                  v-for="group in groups"
                  :key="group.code"
                  :value="group.code"
                >
                  {{ group.name }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>

        <div
          v-for="(item, index) in edit_payee_company.payee_company_contacts"
          :key="index + 1"
        >
            <span class="edit-company-contact-title">收货信息 - {{ index + 1 }}</span>
            <Poptip
              confirm
              title="您确认删除此信息吗？"
              @on-ok="deletePayeeCompanyContact(item.id, index, edit_payee_company.id)"
            >
              <Button
                size="small"
              >
                删除
              </Button>
            </Poptip>
          <Row :gutter="16">
            <Col :span="8">
              <Form-item
                label="收货地址"
                :prop="'payee_company_contacts.' + index + '.address'"
                :rules="edit_payee_company_contact_rules.address"
              >
                <i-input
                  v-model.trim="item.address"
                  placeholder="请输入收货地址"
                />
              </Form-item>
            </Col>
            <Col :span="8">
              <Form-item
                label="收件人名称"
                :prop="'payee_company_contacts.' + index + '.contact_person'"
                :rules="edit_payee_company_contact_rules.contact_person"
              >
                <i-input
                  v-model.trim="item.contact_person"
                  placeholder="请输入收件人名称"
                />
              </Form-item>
            </Col>
            <Col :span="8">
              <Form-item
                label="收件人电话"
                :prop="'payee_company_contacts.' + index + '.phone'"
                :rules="edit_payee_company_contact_rules.phone"
              >
                <i-input
                  v-model.trim="item.phone"
                  placeholder="请输入收件人电话"
                />
              </Form-item>
            </Col>
          </Row>
        </div>
        <Form-item>
          <Button
            type="dashed"
            long
            icon="md-add"
            @click="addPayeeCompanyContact"
          >
            新增收货信息
          </Button>
        </Form-item>

        <Row :gutter="4">
          <i-col span="5">
            <Form-item
              label="供应商类型"
              prop="company_type"
            >
              <RadioGroup v-model="edit_payee_company.company_type">
                <Radio :label="0">
                  个人
                </Radio>
                <Radio :label="1">
                  公司
                </Radio>
              </RadioGroup>
            </Form-item>
          </i-col>
          <i-col
            v-show="edit_payee_company.company_type === 0"
            span="12"
          >
            <Form-item
              label="个人证件号"
              prop="id_number"
            >
              <i-input
                v-model.trim="edit_payee_company.id_number"
                placeholder="个人证件号"
              />
            </Form-item>
          </i-col>
        </Row>
        <Row :gutter="4">
          <i-col span="10">
            <Form-item
              label="联系人"
              prop="contacts"
            >
              <i-input
                v-model.trim="edit_payee_company.contacts"
                placeholder="请输入供应商联系人..."
              />
            </Form-item>
          </i-col>
          <i-col span="10">
            <Form-item
              label="联系电话"
              prop="tel_no"
            >
              <i-input
                v-model.trim="edit_payee_company.tel_no"
                placeholder="请输入供应商联系电话,多个号码以中文顿号隔开..."
              />
            </Form-item>
          </i-col>
        </Row>

        <Row :gutter="4">
          <i-col span="10">
            <Form-item
              label="微信"
              prop="wechat_no"
            >
              <i-input
                v-model.trim="edit_payee_company.wechat_no"
                placeholder="请输入供应商微信..."
              />
            </Form-item>
          </i-col>
          <i-col span="10">
            <Form-item
              label="QQ"
              prop="qq_no"
            >
              <i-input
                v-model.trim="edit_payee_company.qq_no"
                placeholder="请输入供应商QQ..."
              />
            </Form-item>
          </i-col>
        </Row>

        <Row :gutter="4">
          <i-col span="5">
            <Form-item
              label="黑名单"
              prop="is_abnormal"
            >
              <Checkbox v-model="edit_payee_company.is_abnormal">
                列入黑名单
              </Checkbox>
            </Form-item>
          </i-col>
          <i-col
            v-show="edit_payee_company.is_abnormal"
            span="18"
          >
            <Form-item
              label="原因"
              prop="is_abnormal"
            >
              <i-input
                v-model="edit_payee_company.abnormal_reason"
                placeholder="备注列入黑名单的原因"
              />
            </Form-item>
          </i-col>
        </Row>
        <Row :gutter="4">
          <i-col span="5">
            <Form-item
              label="废弃"
              prop="del"
            >
              <Checkbox v-model="edit_payee_company.del">
                废弃
              </Checkbox>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="供应商备注">
          <i-input
            v-model="edit_payee_company.desc"
            type="textarea"
            :rows="2"
          />
        </Form-item>

        <!--
            <Form-item label="供应商合作商品信息">
                <i-input type="textarea" :rows="2" v-model="edit_payee_company.cop_item_info"></i-input>
        </Form-item>-->

        <!--新增供应商合作商品信息,人工维护(目前)-->
        <div v-if="inGroup('GROUP_MALL')">
          <div
            v-for="(item, index) in edit_payee_company.payee_company_cooperation_infos"
            :key="index"
            class="edit-company-account-container"
          >
            <div class="edit-company-account-title">
              <span>合作商品 - {{ index+1 }}</span>
              <Poptip
                confirm
                title="您确认删除此合作商品吗？"
                @on-ok="deletePayeeCompanyCooperationInfo(edit_payee_company, item, index)"
              >
                <Button
                  size="small"
                  icon="md-close"
                >
                  删除
                </Button>
              </Poptip>
            </div>
            <Row :gutter="4">
              <i-col span="8">
                <Form-item
                  :prop="'payee_company_cooperation_infos['+index+'].short_name'"
                  :rules="{required: true, message: '合作商品名称不能为空', trigger: 'blur'}"
                  label="合作商品名称"
                >
                  <i-input
                    v-model="item.short_name"
                    size="small"
                  />
                </Form-item>
              </i-col>
              <i-col span="8">
                <Form-item
                  :prop="'payee_company_cooperation_infos['+index+'].inner_name'"
                  :rules="{required: true, message: '合作商品存货编码不能为空', trigger: 'blur'}"
                  label="合作商品存货编码"
                >
                  <!--
                <i-input
                    v-model="item.inner_name"
                    size="small"
                  />-->
                  <OnlineStockSelector @on-change="setInnerName(item, ...arguments)">
                    <Button
                      size="small"
                      long
                    >
                      <span v-if="item.inner_name">{{ item.inner_name }}</span>
                      <span
                        v-else
                        class="color-grey"
                      >请选择</span>
                    </Button>
                  </OnlineStockSelector>
                </Form-item>
              </i-col>
            </Row>
          </div>
        </div>
        <Button
          v-if="inGroup('GROUP_MALL')"
          type="dashed"
          long
          icon="md-add"
          @click="addPayeeCompanyCooperationInfo"
        >
          新增合作商品信息
        </Button>

        <div
          v-for="(account, index) in edit_payee_company.payee_company_accounts"
          :key="index"
          class="edit-company-account-container"
        >
          <div class="edit-company-account-title">
            <span>付款账号 - {{ index+1 }}</span>
            <Poptip
              confirm
              title="您确认删除此账户吗？"
              @on-ok="deletePayeeCompanyAccount(edit_payee_company, account, index)"
            >
              <Button
                size="small"
                icon="md-close"
              >
                删除
              </Button>
            </Poptip>
          </div>
          <div class="line">
            <span>账号备注:</span>
            <i-input
              v-model="account.remark"
              size="small"
              style="width: 180px"
            />
          </div>
          <Row :gutter="4">
            <i-col span="8">
              <Form-item
                :prop="'payee_company_accounts['+index+'].bank'"
                :rules="{required: true, message: '开户行不能为空', trigger: 'blur'}"
                label="开户行"
              >
                <i-input
                  v-model="account.bank"
                  size="small"
                />
              </Form-item>
            </i-col>
            <i-col span="8">
              <Form-item
                :prop="'payee_company_accounts['+index+'].account'"
                :rules="{required: true, message: '账户名不能为空', trigger: 'blur'}"
                label="账户名"
              >
                <i-input
                  v-model="account.account"
                  size="small"
                />
              </Form-item>
            </i-col>
            <i-col span="8">
              <Form-item
                :prop="'payee_company_accounts['+index+'].bank_type'"
                :rules="bank_type_rules"
                label="账户类型"
              >
                <Select
                  v-model="account.bank_type"
                  size="small"
                >
                  <Option :value="-1">
                    未设置
                  </Option>
                  <Option :value="0">
                    银行卡
                  </Option>
                  <Option :value="10">
                    PayPal
                  </Option>
                  <Option :value="20">
                    支付宝
                  </Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="4">
            <i-col span="8">
              <Form-item
                :prop="'payee_company_accounts['+index+'].bank_number'"
                :rules="{required: true, message: '账号不能为空', trigger: 'blur'}"
                label="卡号 / 账号"
              >
                <i-input
                  v-model="account.bank_number"
                  size="small"
                />
              </Form-item>
            </i-col>
            <i-col span="8">
              <Form-item label="开户省">
                <i-input
                  v-model="account.province"
                  size="small"
                />
              </Form-item>
            </i-col>
            <i-col span="8">
              <Form-item label="开户市">
                <i-input
                  v-model="account.city"
                  size="small"
                />
              </Form-item>
            </i-col>
          </Row>
        </div>
      </Form>
      <Button
        type="dashed"
        long
        icon="md-add"
        @click="addPayeeCompanyAccount"
      >
        新增账户
      </Button>
    </Modal>
  </div>
</template>

<style scoped>
.payee-company-container {
  position: center;
}
.card {
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddee1;
  text-align: left;
}
.card-title {
  width: 250px;
  height: 29px;
  font-size: 20px;
  font-family: SourceHanSansSC-Bold, SourceHanSansSC;
  font-weight: bold;
  color: rgba(75, 84, 104, 1);
  line-height: 29px;
}
.card-title1 {
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}
.card-tip {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.card-btn {
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.card-btn:hover {
  color: #2b62e4;
}
.card-item {
  /*padding: 10px;*/
  margin-top: 10px;
}

.linestyle {
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: rgba(75, 84, 104, 1);
}

.flexd {
  display: inline-block;
  width: 80px;
  height: 36px;
}

.flexd_second {
  display: inline-block;
  width: 1534px;
}

.linestyle-show {
  color: rgba(75, 84, 104, 0.8);
  font-size: 12px;
}

.cs_item_view {
  float: left;
  margin-top: 5px;
  margin-right: 10px;
}
.edit-company-contact-title{
  margin-right: 10px;
}
</style>
